import { render, staticRenderFns } from "./upload-student.vue?vue&type=template&id=b632f2ac&"
import script from "./upload-student.vue?vue&type=script&lang=js&"
export * from "./upload-student.vue?vue&type=script&lang=js&"
import style0 from "./upload-student.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports